<div class="row">
    <div class="col-lg-12">
        <h4 class="upper">Indirizzo Spedizione</h4>
    </div>
    <div class="col-lg-12 form-group">
        Italia
    </div>
    <div class="col-lg-6 form-group">
        <label class="sr-only">Ragione Sociale</label>
        <input type="text" class="form-control"  placeholder="Ragione Sociale" [(ngModel)]="indirizzoFatturazione.ragsoc">
    </div>
    <div class="col-lg-6 form-group">
        <label class="sr-only">Email</label>
        <input type="text" class="form-control" placeholder="Email"  [(ngModel)]="indirizzoFatturazione.email">
    </div>
    <div class="col-lg-6 form-group">
        <label class="sr-only">Telefono</label>
        <input type="text" class="form-control" placeholder="Telefono"  [(ngModel)]="indirizzoFatturazione.telefono">
    </div>
    <div class="col-lg-12 form-group">
        <label class="sr-only">Indirizzo</label>
        <input type="text" class="form-control" placeholder="Indirizzo"  [(ngModel)]="indirizzoFatturazione.indirizzo">
    </div>
    
    <div class="col-lg-6 form-group">
        <label class="sr-only">Città</label>
        <input type="text" class="form-control" placeholder="Città"  [(ngModel)]="indirizzoFatturazione.localita">
    </div>
    <div class="col-lg-6 form-group">
        <label class="sr-only">Provincia</label>
        <input type="text" class="form-control" placeholder="Provincia"  [(ngModel)]="indirizzoFatturazione.provincia">
    </div>
    <div class="col-lg-6 form-group">
        <label class="sr-only">CAP</label>
        <input type="text" class="form-control" placeholder="CAP"  [(ngModel)]="indirizzoFatturazione.cap">
    </div>

    <div class="col-lg-12">
        <button class="btn icon-left float-right mt-3"  (click)="salvaIndirizzo()"><span>Salva</span></button>
        <button class="btn icon-left float-right mt-3 mx-3"  (click)="closeDialog()"><span>Annulla</span></button>
    </div>
</div>